import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class OrganizationNotFoundException extends PointsAccountingException {

}
